var map = {
	"./Hepsiburada AI Hackathon/hackathon.jpeg": 51,
	"./Teknofest - Efficiency Challenge/elektroaydın 1.jpeg": 121,
	"./Teknofest - Efficiency Challenge/elektroaydın 2.jpeg": 456,
	"./Teknofest - Efficiency Challenge/elektroaydın 3.png": 142,
	"./Teknofest - International UAV Competition/iha 1.jpeg": 745,
	"./Teknofest - International UAV Competition/iha 2.jpeg": 976,
	"./Teknofest - International UAV Competition/iha 3.jpeg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;